<template>
  <v-content style="background-color: #f9f9f9;">
    <div class="point text-center" v-if="dispType === 0 || dispType === 1">
      <div style="height: 12px" ></div>
      <span class="headder">こちらの画面をスタッフに提示して下さい</span>
      <div style="height: 15px"></div>
      <span class =""> ポイントカード番号</span>
      <barcode v-if = "this.barcode_format !== ''" v-model="point.ext_point_barcode" :options="{ format: this.barcode_format,displayValue: true}"></barcode>
      <div style="height: 35px"></div>
      <span class="headder " style="line-height:30px;height:30px;width:100%;background-color: #DEDEDF">保有ポイント</span>
      <div style="height: 25px"></div>
      <img @click.stop="getPoint()" src="@/assets/reboot.svg">
      <div style="height: 12px"></div>
      <span class="bigpoint3 ">{{point.point}}</span>
      <div style="height: 10px"></div>
      <span class="smallpoint ">point</span>
      <div v-if="pointResultCode == 0 || pointResultCode == 1" class="text-center" style="margin-top: 10px;">
        <div style="display:inline-block; ">
          <div v-if="pointResultCode == 0"  style="font-weight: bold;">
            有効期限： <span style="display: inline-block; width: 140px;">{{  this.point.lapse_due_date == '19000101' ? getDateFormat(this.point.expiration_date) : getDateFormat(this.point.lapse_due_date) }}</span>
          </div>
          <div v-if="pointResultCode == 1" style="font-weight: bold;">
            有効期限： <span style="display: inline-block; width: 140px;">{{  this.point.status == 903 ? '-' : '' }}</span>
          </div>
          <p style="font-size: 13px; margin-top: 5px; opacity: 0.7;">※有効期限はご購入日の翌日以降に更新されます。</p>
        </div>
      </div>
    </div>
    <div v-if="dispType === 2" class="point text-center">
      <div style="height: 150px"></div>
      <span class="spanmessage">既にお持ちのカード情報を連携される方はこちらから</span>
      <v-btn rounded class="maincolor-bg default_button2" @click.stop="gotoCamera()">ポイントカードをお持ちの方</v-btn>
      <div style="height: 50px"></div>
      <span class="spanmessage">新規登録をされる方はこちらから</span>
      <v-btn rounded class="maincolor-btn2 default_button2" @click.stop="getCardNumber()">ポイントカードをお持ちでない方</v-btn>
      <div style="height: 20px"></div>
      <span class="spanmessage error--text">＊アプリにて新規登録した場合</span>
      <span class="spanmessage error--text">カードとの連携出来なくなりますのでご注意ください。</span>
    </div>
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="" indeterminate></v-progress-circular>
    </v-overlay>
  </v-content>
</template>

<script>
import moment from "moment"
export default {
  data: () => ({
    init: [],
    point:  {point: '', ext_point_barcode: ""},
    pointResultCode: -1,
    barcode_type: null,
    loading: false,
  }),
  created () {
    this.init = this.storageGet("*")
  },
  async mounted() {
    this.loading = true
    try {
      await this.getPoint()
      this.loading = false
    }catch (e) {
      this.loading = false
    }
  },
  computed: {
    dispType(){
      return this.pointResultCode
    },
    barcode_format(){
      let barcodeType = ""
      switch (this.init.external_point_barcode_type){
        case 1:
          barcodeType = 'EAN13'
          break;
        case 2:
          barcodeType = 'CODE128'
          break;
      }
      return barcodeType
      // CODE128 :CODE128
      // EAN / UPC :EAN13 UPC EAN8 EAN5 EAN2
      // CODE39 :CODE39
      // ITF-14 :ITF14
      // MSI :MSI MSI10 MSI11 MSI1010 MSI1110
      // Pharmacode :pharmacode
      // Codabar :codabar
    },
  },
  methods: {
    getDateFormat(date) {
      var d = moment(date);
      if(d.isValid()) {
        return d.format('YYYY年MM月DD日');
      }
      return date;
    },
    gotoCamera(){
      //ネイティブに送るデータを生成
      var tonative_req = {
        'destination': 'barcodeActivity',
        'feature_id': 'barcode',
        'screen_id': 'barcode_scan',
        'transition_type': 2,
        'barcode_format': this.init.external_point_barcode_type,  //1  DBのexternal_point_barcode_typeの値 1:EAN13
        'back_url': this.getDomain() + 'sp/point-external/point', //戻るボタン押下時のURL 不要なら削除
        'input_url': this.getDomain() + 'sp/point-external/point-regist', //ポイントカード番号を手入力する押下時のURL
      };
      if (!(this.screenTransition(tonative_req))) {
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }
    },
    async getCardNumber() {
      this.loading = true
      // 画面再描画時用にsetTimeoutしてthis.loading,this.getPoint等の描画に余裕を持たせる。
      setTimeout( async () => {
        try {
          // ポイント情報取得API
          let req = {params: {
              'shop_id': this.init.sid,
              'user_id': this.init.user_id,
            }}

          let res = await this.apiCall('/point-external/csdelight-numbering', req);
          if (!res) {
            this.loading = false
            return false
          }
          switch (res.result_status){
            case 0:
              //取得できた場合一応getPointを実行する。ただしCSdelightでは紐づけされていないので該当顧客なしが帰ってくる。
              await this.getPoint()
              this.pointResultCode = 0
              break;
            case 1:
              break;
            case 2:
              break;
          }
        } catch(e) {
          this.loading = false
          this.callDialog('接続エラー', '一時的なエラーです。ネットワークの状態が不安定です。再度お試しください', 3);
        }
        this.loading = false
      },100)
    },
    async getPoint() {
      this.loading = true
      // 画面再描画時用にsetTimeoutしてthis.loading等の描画に余裕を持たせる。
      await setTimeout( async () => {
        this.loading = true
        try {
          // ポイント情報取得API
          let req = {params: {
              'shop_id': this.init.sid,
              'user_id': this.init.user_id,
            }}

          let res = await this.apiCall('/point-external/csdelight-show', req);
          if (!res){
            if(this.pointResultCode === -1){this.pointResultCode=0}  //this.pointResultCode ===-1 の場合は初期表示切替前なのでデータエラーでポイント画面を表示する。
            this.loading = false
            return false;
          }
          this.$set(this, 'point', res);
          this.$set(this, 'pointResultCode', res.result_status);
          if(res.status === 903){
            // 903の場合はポイント表示を意図的に「-」に変更する
            this.point.point = '-'
            this.pointResultCode = 0
          }
        } catch(e) {
          this.loading = false
          this.callDialog('接続エラー', '一時的なエラーです。ネットワークの状態が不安定です。再度お試しください', 3);
        }
        this.loading = false
      },100)
    },
  },
};
</script>

<style scoped>
.headder{
  font-weight: bold;
}
img{
  padding-left: 250px;
}
.bigpoint3 {
  font-size: 60px;
  font-weight: bold;
  font-family: "Oswald", sans-serif !important;
  line-height: 1;
}
.spanmessage {
  font-size: 12px;
}
.smallpoint {
  font-size: 24px;
  font-weight: bold;
  font-family: "Oswald", sans-serif !important;
  color: #333333;
}
.point{
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
<style>
.v-application--wrap {
  min-height: 100vh;
  min-height: -webkit-fill-available;
}
</style>
